/**
 * Filtros de cadastro do cliente para regras de automação (objeto Solicitação).
 * Espelha os identificadores do ChatBot ($cpfcliente, !$emailcliente, etc.).
 */

export const CLIENT_FIELD_CONDITION_KEYS = [
  "cliente_cadastro_preenchido",
  "cliente_nome_preenchido",
  "cliente_cpf_preenchido",
  "cliente_cnpj_preenchido",
  "cliente_email_preenchido",
  "cliente_telefone_preenchido",
  "cliente_celular_preenchido",
  "cliente_pessoa_fisica",
  "cliente_pessoa_juridica",
];

const YES_NO_OPTIONS = [
  { value: "1", label: "Sim" },
  { value: "0", label: "Não" },
];

/** Definições exibidas no formulário (select Sim/Não). */
export const CLIENT_FIELD_FORM_DEFS = {
  cliente_cadastro_preenchido: {
    type: "select",
    label: "Cadastro vinculado",
    options: YES_NO_OPTIONS,
    helperText: "Sim = solicitação com cliente no cadastro; Não = sem vínculo.",
  },
  cliente_nome_preenchido: {
    type: "select",
    label: "Nome no cadastro",
    options: YES_NO_OPTIONS,
    helperText: "Verifica se o cadastro vinculado tem nome preenchido.",
  },
  cliente_cpf_preenchido: {
    type: "select",
    label: "CPF no cadastro",
    options: YES_NO_OPTIONS,
    helperText: "Verifica se o cadastro vinculado tem CPF.",
  },
  cliente_cnpj_preenchido: {
    type: "select",
    label: "CNPJ no cadastro",
    options: YES_NO_OPTIONS,
    helperText: "Verifica se o cadastro vinculado tem CNPJ.",
  },
  cliente_email_preenchido: {
    type: "select",
    label: "E-mail no cadastro",
    options: YES_NO_OPTIONS,
    helperText: "Verifica se o cadastro vinculado tem e-mail.",
  },
  cliente_telefone_preenchido: {
    type: "select",
    label: "Telefone no cadastro",
    options: YES_NO_OPTIONS,
    helperText: "Verifica se o cadastro vinculado tem telefone fixo.",
  },
  cliente_celular_preenchido: {
    type: "select",
    label: "Celular no cadastro",
    options: YES_NO_OPTIONS,
    helperText: "Verifica se o cadastro vinculado tem celular.",
  },
  cliente_pessoa_fisica: {
    type: "select",
    label: "Cliente é pessoa física?",
    options: YES_NO_OPTIONS,
    helperText: "Sim = cadastro PF (tipo 0 ou CPF sem CNPJ). Não = PJ ou tipo indefinido.",
  },
  cliente_pessoa_juridica: {
    type: "select",
    label: "Cliente é pessoa jurídica?",
    options: YES_NO_OPTIONS,
    helperText: "Sim = cadastro PJ (tipo 1 ou CNPJ informado). Não = PF ou tipo indefinido.",
  },
};

/** Agrupamento visual no seletor de condições. */
export const CLIENT_FIELD_GROUPS = [
  {
    fieldKey: "cliente_cadastro_preenchido",
    title: "Cadastro vinculado",
    description: "Se a solicitação está ligada a um cliente no cadastro.",
  },
  {
    fieldKey: "cliente_nome_preenchido",
    title: "Nome",
    description: "Nome completo no cadastro do cliente.",
  },
  {
    fieldKey: "cliente_cpf_preenchido",
    title: "CPF",
    description: "Documento CPF no cadastro.",
  },
  {
    fieldKey: "cliente_cnpj_preenchido",
    title: "CNPJ",
    description: "Documento CNPJ no cadastro.",
  },
  {
    fieldKey: "cliente_email_preenchido",
    title: "E-mail",
    description: "Endereço de e-mail no cadastro.",
  },
  {
    fieldKey: "cliente_telefone_preenchido",
    title: "Telefone",
    description: "Telefone fixo no cadastro.",
  },
  {
    fieldKey: "cliente_celular_preenchido",
    title: "Celular",
    description: "Celular / WhatsApp no cadastro.",
  },
  {
    fieldKey: "cliente_pessoa_fisica",
    title: "Pessoa física",
    description: "Cadastro de pessoa física (CPF, tipo PF).",
  },
  {
    fieldKey: "cliente_pessoa_juridica",
    title: "Pessoa jurídica",
    description: "Cadastro de pessoa jurídica (CNPJ, tipo PJ).",
  },
];

/** Presets aplicados ao adicionar filtro (valor já definido). */
export const CLIENT_FIELD_FILTER_PRESETS = [
  {
    key: "cliente_cadastro_preenchido",
    fieldKey: "cliente_cadastro_preenchido",
    value: "1",
    shortLabel: "Vinculado",
    label: "Cliente vinculado ao cadastro",
    hint: "Dispara quando a solicitação tem cadastro associado",
  },
  {
    key: "cliente_cadastro_preenchido",
    fieldKey: "cliente_cadastro_preenchido",
    value: "0",
    shortLabel: "Sem vínculo",
    label: "Sem cadastro vinculado",
    hint: "Dispara quando a solicitação não tem cliente no cadastro",
  },
  {
    key: "cliente_nome_preenchido",
    fieldKey: "cliente_nome_preenchido",
    value: "1",
    shortLabel: "Preenchido",
    label: "Nome preenchido no cadastro",
    hint: "Como $nomecliente no ChatBot — informação já disponível",
  },
  {
    key: "cliente_nome_preenchido",
    fieldKey: "cliente_nome_preenchido",
    value: "0",
    shortLabel: "Ausente",
    label: "Nome ausente no cadastro",
    hint: "Como !$nomecliente — ainda falta coletar o nome",
  },
  {
    key: "cliente_cpf_preenchido",
    fieldKey: "cliente_cpf_preenchido",
    value: "1",
    shortLabel: "Preenchido",
    label: "CPF preenchido no cadastro",
    hint: "Como $cpfcliente — CPF já informado",
  },
  {
    key: "cliente_cpf_preenchido",
    fieldKey: "cliente_cpf_preenchido",
    value: "0",
    shortLabel: "Ausente",
    label: "CPF ausente no cadastro",
    hint: "Como !$cpfcliente — ainda falta o CPF",
  },
  {
    key: "cliente_cnpj_preenchido",
    fieldKey: "cliente_cnpj_preenchido",
    value: "1",
    shortLabel: "Preenchido",
    label: "CNPJ preenchido no cadastro",
    hint: "Como $cnpjcliente — CNPJ já informado",
  },
  {
    key: "cliente_cnpj_preenchido",
    fieldKey: "cliente_cnpj_preenchido",
    value: "0",
    shortLabel: "Ausente",
    label: "CNPJ ausente no cadastro",
    hint: "Como !$cnpjcliente — ainda falta o CNPJ",
  },
  {
    key: "cliente_email_preenchido",
    fieldKey: "cliente_email_preenchido",
    value: "1",
    shortLabel: "Preenchido",
    label: "E-mail preenchido no cadastro",
    hint: "Como $emailcliente — e-mail já informado",
  },
  {
    key: "cliente_email_preenchido",
    fieldKey: "cliente_email_preenchido",
    value: "0",
    shortLabel: "Ausente",
    label: "E-mail ausente no cadastro",
    hint: "Como !$emailcliente — ainda falta o e-mail",
  },
  {
    key: "cliente_telefone_preenchido",
    fieldKey: "cliente_telefone_preenchido",
    value: "1",
    shortLabel: "Preenchido",
    label: "Telefone preenchido no cadastro",
    hint: "Como $telefonecliente — telefone fixo já informado",
  },
  {
    key: "cliente_telefone_preenchido",
    fieldKey: "cliente_telefone_preenchido",
    value: "0",
    shortLabel: "Ausente",
    label: "Telefone ausente no cadastro",
    hint: "Como !$telefonecliente — ainda falta o telefone",
  },
  {
    key: "cliente_celular_preenchido",
    fieldKey: "cliente_celular_preenchido",
    value: "1",
    shortLabel: "Preenchido",
    label: "Celular preenchido no cadastro",
    hint: "Como $celularcliente — celular já informado",
  },
  {
    key: "cliente_celular_preenchido",
    fieldKey: "cliente_celular_preenchido",
    value: "0",
    shortLabel: "Ausente",
    label: "Celular ausente no cadastro",
    hint: "Como !$celularcliente — ainda falta o celular",
  },
  {
    key: "cliente_pessoa_fisica",
    fieldKey: "cliente_pessoa_fisica",
    value: "1",
    shortLabel: "PF",
    label: "Cliente é pessoa física",
    hint: "Dispara quando o cadastro vinculado é PF (tipo 0 ou CPF sem CNPJ)",
  },
  {
    key: "cliente_pessoa_juridica",
    fieldKey: "cliente_pessoa_juridica",
    value: "1",
    shortLabel: "PJ",
    label: "Cliente é pessoa jurídica",
    hint: "Dispara quando o cadastro vinculado é PJ (tipo 1 ou CNPJ informado)",
  },
];

export function isClientFieldConditionKey(key) {
  return CLIENT_FIELD_CONDITION_KEYS.includes(String(key || ""));
}

export function mergeClientFieldConditionsIntoEventSchema(schema = {}) {
  if (!schema || typeof schema !== "object" || Array.isArray(schema)) {
    return { ...CLIENT_FIELD_FORM_DEFS };
  }
  const merged = { ...schema };
  for (const [key, def] of Object.entries(CLIENT_FIELD_FORM_DEFS)) {
    if (!Object.prototype.hasOwnProperty.call(merged, key)) {
      merged[key] = def;
    }
  }
  return merged;
}

export function listAvailableClientFieldPresets(usedKeys = new Set()) {
  return CLIENT_FIELD_FILTER_PRESETS.filter((preset) => !usedKeys.has(preset.key));
}
